const ACTION_KEY = 'VERIFICATION_REPORT';

const initialState = () => ({
  loading: false,
  pdfBuffer: null,
  fileName: null,
  errors: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      const { errors } = action.payload;

      return {
        ...state,
        errors,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const { fileName, pdfBuffer } = action.payload;

      return {
        ...state,
        loading: false,
        errors: null,
        pdfBuffer,
        fileName
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
